module.exports = __webpack_public_path__ + "img/software-thumb-1.a4438372.png";